/*
 * Section: Productos de colección (sections/collection-products-grid.liquid)
 * Loads the next page of the collection with the Section Rendering API and
 * appends it to the grid ("Cargar más" button or infinite scroll).
 */
(function () {
  if (customElements.get('collection-products-grid')) return;

  let batchUid = 0;

  class CollectionProductsGrid extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-cpg-grid]');
      if (!this.grid) return;
      this.loading = false;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.observeInfinite();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.observer) this.observer.disconnect();
    }

    onClick(event) {
      const link = event.target.closest('[data-cpg-next]');
      if (!link || !this.contains(link)) return;
      event.preventDefault();
      this.loadNext(link);
    }

    async loadNext(link) {
      if (this.loading) return;
      this.loading = true;
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');

        const batch = html.querySelector('[data-cpg-batch]');
        if (batch) {
          batch.id = `cpg-batch-${++batchUid}`;
          this.grid.appendChild(document.importNode(batch, true));
          this.initBatch(`#${batch.id}`);
        }

        const footer = this.querySelector('[data-cpg-footer]');
        const nextFooter = html.querySelector('[data-cpg-footer]');
        if (footer && nextFooter) {
          footer.replaceWith(document.importNode(nextFooter, true));
        } else if (footer) {
          footer.remove();
        }
      } catch (error) {
        console.error('[collection-products-grid]', error);
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
      }

      this.loading = false;
      this.observeInfinite();
    }

    observeInfinite() {
      if (this.observer) this.observer.disconnect();
      if (this.dataset.pagination !== 'infinite') return;
      const link = this.querySelector('[data-cpg-next]');
      if (!link) return;
      if (!('IntersectionObserver' in window)) {
        link.classList.remove('cpg__load-more--infinite');
        return;
      }
      // The last card works for both layouts: in the mobile carousel it is
      // clipped by the horizontal scroller until the shopper swipes to it.
      const items = this.grid.querySelectorAll('.cpg__item');
      const target = items[items.length - 1] || link;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNext(link);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(target);
    }

    // Re-run the theme's product card scripts on the new cards only, so the
    // wishlist/compare buttons already on the page are not bound twice.
    initBatch(selector) {
      const run = (fn) => {
        try {
          fn();
        } catch (error) {
          console.error('[collection-products-grid]', error);
        }
      };
      const $ = window.jQuery;
      const wp = window.wpbingo;

      if ($ && wp) {
        const $batch = $(selector);
        if (typeof wp.load_swiper_carousel === 'function') {
          run(() =>
            $batch.find('.product-card__image-wrapper.slider .bwp-swiper-slider').each(function () {
              if (!$(this).hasClass('swiper-initialized')) wp.load_swiper_carousel($(this));
            })
          );
        }
        if (typeof wp.countdown === 'function') run(() => wp.countdown(`${selector} [data-countdown]`));
        if ($.fn.zoom) run(() => $batch.find('.product-card__image-wrapper.zoom .product-card__image').zoom());
        if (typeof wp.click_atribute_image === 'function') run(() => wp.click_atribute_image());
        if (typeof wp.popup_product_card === 'function') run(() => wp.popup_product_card());
        if ($('.bwp_currency').length && window.Currency) run(() => window.Currency.Currency_customer(true));
      }
      /* global initButtons, initButtonsCompare -- top-level consts in wpbingo.js */
      if (typeof initButtons === 'function') run(() => initButtons(selector));
      if (typeof initButtonsCompare === 'function') run(() => initButtonsCompare(selector));
    }
  }

  customElements.define('collection-products-grid', CollectionProductsGrid);
})();
